import React from 'react';
import { WidgetType } from '../../types/api/ElementType';
import { OrgUnitMembershipsWidget } from '../../_widgets/OrgUnitMemberships';
import { TopicMembershipsWidget } from '../../_widgets/TopicMemberships';
import { ProcessMembershipsWidget } from '../../_widgets/ProcessMemberships';
import { LocationMembershipsWidget } from '../../_widgets/LocationMemberships';
import { ConnectedUsersWidget } from '../../_widgets/ConnectedUsers';
import { PersonProfileEditHintWidget } from '../../_widgets/PersonProfileEditHint';
import { PersonExtendedDataWidget } from '../../_widgets/PersonExtendedData';
import { UserInfoWidget } from '../../_widgets/UserInfo';
import { ExternalLinksWidget } from '../../_widgets/ExternalLinks';

type PersonalProfileWidget =
  | TopicMembershipsWidget
  | PersonExtendedDataWidget
  | ConnectedUsersWidget
  | OrgUnitMembershipsWidget
  | LocationMembershipsWidget
  | ProcessMembershipsWidget
  | PersonProfileEditHintWidget
  | UserInfoWidget;

export type PersonalProfileLayout = {
  contentSection: { widgets: PersonalProfileWidget[] };
};

/**
 * Three column Layout Template for PersonalProfileLayout page.
 * All Widgets are inside the contentSection -> no generic mapping of widgets possible.
 */
export function PersonalProfileLayout({ contentSection }: PersonalProfileLayout) {
  const { widgets } = contentSection;

  function find<T>(widgetType: WidgetType): T | undefined {
    return widgets.find(widget => widget.elementType === widgetType) as T;
  }

  const topicMembershipsWidget = find<TopicMembershipsWidget>(WidgetType.topicMemberships);
  const orgunitMembershipsWidget = find<OrgUnitMembershipsWidget>(WidgetType.orgunitMemberships);
  const locationMembershipsWidget = find<LocationMembershipsWidget>(WidgetType.locationMemberships);
  const processMembershipsWidget = find<ProcessMembershipsWidget>(WidgetType.processMemberships);
  const connectedUsersWidget = find<ConnectedUsersWidget>(WidgetType.connectedUsers);
  const personProfileEditHintWidget = find<PersonProfileEditHintWidget>(WidgetType.personprofileedithint);
  const externalLinksWidget = find<ExternalLinksWidget>(WidgetType.userexternallinks);
  const personExtendedData = find<PersonExtendedDataWidget>(WidgetType.personextendeddata);
  const userInfoWidget = find<UserInfoWidget>(WidgetType.userinfo);

  return (
    <>
      <div className="content-three-columns-column-generic">
        {personProfileEditHintWidget && <PersonProfileEditHintWidget {...personProfileEditHintWidget} />}
        {userInfoWidget && <UserInfoWidget {...userInfoWidget} />}
      </div>
      <div className="content-three-columns-column-generic">
        {personExtendedData && <PersonExtendedDataWidget {...personExtendedData} />}
        {externalLinksWidget && <ExternalLinksWidget {...externalLinksWidget} />}
        {connectedUsersWidget && <ConnectedUsersWidget {...connectedUsersWidget} />}
        {orgunitMembershipsWidget && <OrgUnitMembershipsWidget {...orgunitMembershipsWidget} />}
        {locationMembershipsWidget && <LocationMembershipsWidget {...locationMembershipsWidget} />}
        {processMembershipsWidget && <ProcessMembershipsWidget {...processMembershipsWidget} />}
      </div>
      <div className="content-three-columns-column-generic">
        {topicMembershipsWidget && <TopicMembershipsWidget {...topicMembershipsWidget} />}
      </div>
    </>
  );
}
